<template>
  <div v-if="visible" class="role-select-wrapper">
    <div class="content">
      <div class="top">确认账号</div>
      <div class="mid">
        <div class="row">
          <span class="label">当前账号：</span>
          <span class="value">{{ account || '-' }}</span>
        </div>
        
      </div>
      <div class="footer">
        <div class="role-select-dialog__btn role-select-dialog__btn--cancel" @click="onChangeAccount">更换账号</div>
        <div class="role-select-dialog__btn role-select-dialog__btn--confirm" @click="onConfirm">确认绑定</div>
      </div>
    </div>
    <img class="close" :src="closeImg" alt="" @click="onClose" />
  </div>
</template>

<script>
import { CDN_URL } from '@/config/index.js';

export default {
  name: 'RoleSelectDialog',
  data() {
    return {
      visible: false,
      account: '',
      closeImg: `${CDN_URL}/imperialGlory/dialog-mid-close.png`,
    };
  },
  methods: {
    open(account = '') {
      this.account = account;
      this.visible = true;
    },
    onChangeAccount() {
      this.visible = false;
      this.$emit('change-account');
    },
    onClose() {
      this.visible = false;
      this.$emit('close');
    },
    onConfirm() {
      this.$emit('confirm', {
        account: this.account,
      });
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.role-select-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 102;
  background-color: rgba(0, 0, 0, 0.5);

  .content {
    width: 312px;
    min-height: 196px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 148px auto 10px auto;
    display: flex;
    flex-direction: column;

    .top {
      width: 100%;
      height: 38px;
      text-align: center;
      line-height: 38px;
      color: #fff;
      background: #fe4f4a;
      font-size: 17px;
      font-weight: 700;
    }

    .mid {
      flex: 1;
      display: flex;
      align-items: center;
      padding: 22px 20px 18px;

      .row {
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: center;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .label {
        flex-shrink: 0;
        font-size: 12px;
        color: #333;
      }

      .value {
        font-size: 12px;
        color: #FF5043;
      }

      .role-select {
        width: 190px;
        height: 34px;
        border: none;
        outline: none;
        background: #f3f3f3;
        border-radius: 6px;
        font-size: 12px;
        color: #333;
        padding: 0 10px;
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      gap: 22px;
      padding: 0 0 24px;
    }

    .role-select-dialog__btn {
      width: 121.5px;
      height: 38.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      text-align: center;
      border-radius: 19.5px;
      font-size: 15px;
      font-weight: 400;
      box-sizing: border-box;
    }

    .role-select-dialog__btn--cancel {
      color: #ff5043;
      background: #fff;
      border: 1px solid #ff5043;
    }

    .role-select-dialog__btn--confirm {
      color: #fff;
      border: none;
      background: #ff5043;
    }
  }

  .close {
    width: 30px;
    display: block;
    margin: 0 auto;
    background-color: #fe4f4a;
    border-radius: 50%;
  }
}
</style>
